import React, { useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import MarketDrawer from "pages/BasicTrade/components/MarketDrawer";
import TradeHead from "pages/BasicTrade/components/TradeHead";
import TradingViewChart from "pages/BasicTrade/components/TradeChartView/Components/TradingViewChart";
import { TradingViewHeader } from "pages/BasicTrade";
import { getSingleMarketLoggedInList } from "store/slices/market/marketSlice";
import useDispatch from "hooks/useDispatch";
import { useSelector } from "react-redux";
import { ROUTE_PATHS } from "routes/paths";

function AdvancedTradeChart() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMdView = useMediaQuery(theme.breakpoints.down("lg"));
  const [showMarketDrawer, setShowMarketDrawer] = useState(false);

  const { source, destination } = useParams();
  const dispatch = useDispatch();

  const coinMarketDetails = useSelector(
    (state) => state.market.singleMarketLoggedInList
  );

  const destinations = useSelector(
    (state) => state.market.marketLoggedInForm?.data?.lisCoinDestination
  );

  return (
    <>
      <TradingViewHeader>
        <TradeHead
          navigationPath="/advanced-trade"
          hideActions={!isMdView}
          getSingleMarketLoggedInList={() =>
            dispatch(
              getSingleMarketLoggedInList({
                coinSourceId: source,
                coinDestinationId: destination,
              })
            )
          }
          setShowMarketDrawer={setShowMarketDrawer}
          coinMarketDetails={coinMarketDetails}
          destinations={destinations}
        />
      </TradingViewHeader>

      <TradingViewChart
        height="380"
        symbol={coinMarketDetails?.coinSourceName}
      />

      <MarketDrawer
        onRowClick={(row) => {
          navigate(ROUTE_PATHS.trade.advanced(row?.data?.coinSourceId, row?.data?.coinDestinationId));

          setShowMarketDrawer(false);
        }}
        open={showMarketDrawer}
        onClose={() => setShowMarketDrawer(false)}
        destinations={destinations}
      />
    </>
  );
}

export default AdvancedTradeChart;
